import { DocActionButton } from '@barthauer/abc/ui-components';

export class DocumentModel {
  Comment: string;
  DataCarrier: string;
  Date: string;
  DateEnd: string;
  DateStart: string;
  Designation: string;
  Kind: string;
  FileName: string;
  Id: string;
  InsertDate: string;
  Number: string;
  Object: string;
  ParentId: string;
  ProgramPath: string;
  UpdateDate: string;
  ValidFrom: string;
  ValidUntil: string;
  Extension: string;
  Buttons: DocActionButton[];
  constructor(data?: any) {
    Object.assign(this, data);
  }
}

export class DocInfo {
  Designation: string;
  Date: string | number | Date;
  FileName: string;
  Kind: string;

  constructor(data) {
    this.Designation = data.name;
    this.Date = new Date();
    this.FileName = data.name;
    this.Kind = data.type;
  }
}
